<template>
  <div class="alarmManagement mainPageBg"
    v-loading="$store.state.user.loadingState">
    <div class="statisticsWrap">
      <CardListCom :cardList="statisticsList" />
    </div>
    <div class="bottomWrap">
      <div class="contentWrap">
        <el-form :inline="true"
          :model="formInline"
          class="demo-form-inline">
          <el-form-item label="时间范围">
            <el-date-picker v-model="formInline.timeData"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              unlink-panels
              format="yyyy-MM-dd"
              value-format="timestamp"
              :picker-options="pickerOptions"
              :clearable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="设备区域">
            <el-cascader v-model="formInline.areaId"
              :options="areaList"
              clearable
              placeholder="请选择"
              :show-all-levels="false"
              :props="{
                checkStrictly: true,
                value: 'id',
                label: 'name',
                emitPath: false,
              }"></el-cascader>
          </el-form-item>
          <el-form-item label="报警级别">
            <el-select v-model="formInline.level">
              <el-option label="全部级别"
                value="all"> </el-option>
              <el-option label="高危"
                value="CRITICAL"> </el-option>
              <el-option label="危险"
                value="MAJOR"> </el-option>
              <el-option label="警告"
                value="MINOR"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报警类型">
            <el-select v-model="formInline.alarmType">
              <el-option label="全部"
                value="all"> </el-option>
              <el-option v-for="item in alarmTypeList"
                :key="item.name"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理状态">
            <el-select v-model="formInline.handleStatus">
              <el-option label="全部"
                value="all"> </el-option>
              <el-option label="已转工单"
                value="true"> </el-option>
              <el-option label="未转工单"
                value="false"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="搜索">
            <el-input v-model="formInline.searchTxt"
              placeholder="请输入设备名称/位置">
            </el-input>
          </el-form-item>
          <el-form-item style="margin-left: 20px">
            <el-button type="primary"
              @click="handleClickTab">查 询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetClick">重 置</el-button>
          </el-form-item>
        </el-form>
        <div style="margin-bottom: 10px">
          <el-radio-group v-model="stateActive"
            size="mini"
            style="margin-right: 10px"
            @change="handleClickTab">
            <el-radio-button label="all">全部</el-radio-button>
            <el-radio-button label="false">未确认</el-radio-button>
            <el-radio-button label="true">已确认</el-radio-button>
          </el-radio-group>
          <el-button size="mini"
            v-if="judgeAuthority('shebei:alarmManagement:export')"
            type="primary" plain
            @click="exportExcel"><i class="el-icon-download el-icon--left"></i>EXCEL</el-button>
          <el-button size="mini"
            v-if="judgeAuthority('shebei:alarmManagement:edit')"
            @click="batch">标记确认</el-button>
        </div>
        <div class="tabComBox">
          <AlarmTableCom :tabHead="tabHead"
            :tableData="tableList"
            ref="componentAlarmTable"
            showCheckbox />
        </div>
        <el-pagination @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 30, 50]"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
          style="text-align: right; margin-top: 10px">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import {
  dateFtt,
  matchingAlarmLevel,
  judgeAuthority,
  exportExcelFun,
} from "@/assets/js/utils";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
import AlarmTableCom from "@/components/AlarmTableCom";
import CardListCom from "@/components/DevOps/CardListCom.vue";
export default {
  components: {
    AlarmTableCom,
    CardListCom,
  },
  data() {
    return {
      statisticsList: [
        { name: "今日报警", value: null, key: "今日" },
        { name: "本月报警", value: null, key: "本月" },
        { name: "本年报警", value: null, key: "今年" },
      ],
      formInline: {
        searchTxt: "",
        timeData: [],
        areaId: "",
        level: "all",
        alarmType: "all",
        handleStatus: "all",
      },
      alarmTypeList: [],
      areaList: [],
      stateActive: "all",
      tabHead: [
        { label: "ID", prop: "alarmId" },
        { label: "报警时间", prop: "alarmEndTime" },
        { label: "设备名称", prop: "deviceName" },
        { label: "设备/区域地址", prop: "location" },
        { label: "报警类型", prop: "type" },
        { label: "报警条件", prop: "condition" },
        { label: "当前状态", prop: "status" },
        { label: "正常范围", prop: "range" },
        { label: "确认状态", prop: "handleState" },
        { label: "报警级别", prop: "alarmSeverity" },
      ],
      tableList: [],
      currentPage: 1,
      page: {
        total: null,
        size: 10,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
    };
  },
  methods: {
    judgeAuthority,
    batch() {
      this.$refs.componentAlarmTable.batchProcessing();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getAlarmsList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getAlarmsList();
    },
    async getAlarmsList() {
      this.tableList = [];
      if (
        dateFtt("yyyy-MM-dd", new Date(this.formInline.timeData[1])) ===
        dateFtt("yyyy-MM-dd", new Date())
      ) {
        this.formInline.timeData[1] = new Date(
          dateFtt("yyyy-MM-dd hh:mm:ss", new Date())
        ).getTime();
      } else {
        this.formInline.timeData[1] = new Date(
          dateFtt("yyyy-MM-dd 23:59:59", new Date(this.formInline.timeData[1]))
        ).getTime();
      }
      this.formInline.timeData[0] = new Date(
        dateFtt("yyyy-MM-dd 00:00:00", new Date(this.formInline.timeData[0]))
      ).getTime();
      this.$store.commit("SET_LOADING", true);
      let res = await api.getSAlarmsList({
        page: this.currentPage - 1,
        pageSize: this.page.size,
        beginTs: this.formInline.timeData[0],
        endTs: this.formInline.timeData[1],
        assetId: this.formInline.areaId ? this.formInline.areaId : "",
        key: this.formInline.searchTxt,
        type: this.formInline.level == "all" ? "" : this.formInline.level,
        alarmType:
          this.formInline.alarmType == "all" ? "" : this.formInline.alarmType,
        confirmed:
          this.stateActive == "all" ? "" : JSON.parse(this.stateActive),
        status:
          this.formInline.handleStatus == "all"
            ? ""
            : JSON.parse(this.formInline.handleStatus),
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.page.total = res.data.data.totalElements;
        this.tableList = res.data.data.data;
        this.tableList.map((v) => {
          v.alarmEndTime = dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.endTime));
          v.handleState = v.confirm ? "已确认" : "未确认";
          v.alarmSeverity = matchingAlarmLevel(v.level);
        });
      }
    },
    handleClickTab() {
      this.currentPage = 1;
      this.page.size = 10;
      this.$refs.componentAlarmTable.resetSelection();
      this.getAlarmsList();
    },

    resetClick() {
      this.formInline.searchTxt = "";
      this.formInline.areaId = "";
      this.formInline.level = "all";
      this.formInline.alarmType = "all";
      this.formInline.handleStatus = "all";
      this.setTimeData();
    },
    setTimeData() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.formInline.timeData = [start.getTime(), end.getTime()];
    },
    async getTolData() {
      let res = await api.getSAlarmsTolData({});
      if (res && res.data.code == 200) {
        this.statisticsList.map((v) => {
          v.value = res.data.data[v.key];
        });
      }
    },
    async getAssetsTree() {
      let res = await api.asseList({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        projectName: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectName,
      });
      if (res && res.status == 200) {
        this.areaList = [res.data.assets.区域位置];
      }
    },
    async getAlarmTypeList() {
      let res = await api.getSAlarmTypeList({});
      if (res && res.data.code == 200) {
        this.alarmTypeList = res.data.data;
      }
    },
    exportExcel() {
      exportFile.xlsxFile(XLSX, "报警管理", {
        excel: exportExcelFun(this.tabHead, this.tableList),
      });
    },
  },
  created() {
    this.getAlarmTypeList();
    this.getAssetsTree();
    this.setTimeData();
    this.getTolData();
    this.getAlarmsList();
  },
};
</script>

<style lang="scss" scoped>
.alarmManagement {
  ::v-deep .cell {
    .el-tooltip {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }
  @include setFlexColumn;
  justify-content: space-between;
  align-items: center;
  .statisticsWrap {
    width: 100%;
    height: 15%;
    background: #fff;
  }
  .bottomWrap {
    width: 100%;
    height: calc(85% - 12px);
    background: #fff;
    .contentWrap {
      width: 98%;
      height: 96%;
      margin: 20px auto;
      .tabComBox {
        width: 100%;
        height: 67%;
      }
    }
  }
}
</style>